import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      d="M28.233 12.853c-.472-.493-.96-1-1.143-1.447-.17-.409-.18-1.086-.19-1.742-.019-1.22-.039-2.603-1-3.564s-2.344-.981-3.564-1c-.656-.01-1.333-.02-1.742-.19-.447-.184-.954-.671-1.447-1.142C18.285 2.938 17.306 2 16 2s-2.284.939-3.148 1.768c-.492.47-1 .958-1.446 1.142-.406.17-1.086.18-1.742.19-1.22.019-2.603.039-3.564 1s-.975 2.344-1 3.564c-.01.656-.02 1.334-.19 1.742-.184.446-.671.954-1.142 1.446C2.938 13.715 2 14.696 2 16s.939 2.284 1.768 3.148c.47.492.958 1 1.142 1.446.17.409.18 1.086.19 1.742.019 1.22.039 2.603 1 3.564s2.344.981 3.564 1c.656.01 1.334.02 1.742.19.445.184.954.671 1.446 1.143C13.717 29.06 14.696 30 16 30s2.284-.939 3.148-1.767c.492-.472 1-.96 1.446-1.143.409-.17 1.086-.18 1.742-.19 1.22-.019 2.603-.039 3.564-1s.981-2.344 1-3.564c.01-.656.02-1.333.19-1.742.184-.445.671-.954 1.143-1.447C29.06 18.286 30 17.306 30 16s-.939-2.284-1.767-3.148m-1.444 4.91c-.599.626-1.219 1.272-1.548 2.066-.315.762-.328 1.633-.341 2.477-.012.875-.026 1.791-.415 2.179s-1.299.402-2.179.415c-.844.013-1.715.026-2.477.341-.794.329-1.44.949-2.065 1.548C17.139 27.387 16.5 28 16 28s-1.142-.615-1.764-1.211c-.621-.597-1.271-1.219-2.065-1.548-.762-.315-1.633-.328-2.477-.341-.875-.012-1.792-.026-2.179-.415s-.402-1.299-.415-2.179c-.012-.844-.026-1.715-.341-2.477-.329-.794-.949-1.44-1.548-2.065S4 16.5 4 16s.615-1.142 1.211-1.764c.596-.621 1.219-1.271 1.548-2.065.315-.762.329-1.633.341-2.477.013-.875.026-1.792.415-2.179s1.299-.402 2.179-.415c.843-.012 1.715-.026 2.477-.341.794-.329 1.44-.949 2.065-1.548S15.5 4 16 4s1.142.615 1.764 1.211c.621.596 1.271 1.219 2.065 1.548.762.315 1.633.329 2.477.341.875.013 1.791.026 2.179.415s.402 1.299.415 2.179c.013.843.026 1.715.341 2.477.329.794.949 1.44 1.548 2.065C27.387 14.861 28 15.5 28 16s-.615 1.142-1.211 1.764"
    />
  </svg>
);
const SvgIconSeal = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconSeal);
export default Memo;
